import { colors } from '@styles/vars'
import React from 'react'
import { BaseEditor, Editor, Element, Transforms } from "slate"
import { ReactEditor, useSlate } from "slate-react"
import styled from "styled-components"
import { ElementInterface } from './Element'

export default function BlockButton({ format, icon }: Props) {
    const editor = useSlate()

    return (
        <BlockButtonWrapper active={isBlockActive(editor, format)} onMouseDown={e => {
            e.preventDefault()
            toggleBlock(editor, format)
        }}>
            {icon}
        </BlockButtonWrapper>
    )
}

interface Props {
    icon: React.ReactNode
    format: ElementInterface['type']
}

function isBlockActive(editor: BaseEditor & ReactEditor, format: ElementInterface['type']) {
    const { selection } = editor
    if (!selection) return false
  
    const [match] = Array.from(
      Editor.nodes(editor, {
        at: Editor.unhangRange(editor, selection),
        match: n =>
          !Editor.isEditor(n) && Element.isElement(n) && n.type === format,
      })
    )
  
    return !!match
}

const LIST_TYPES = ['li', 'ul']

function toggleBlock(editor: BaseEditor & ReactEditor, format: ElementInterface['type']) {
    const isActive = isBlockActive(editor, format)
    const isList = LIST_TYPES.includes(format)
  
    Transforms.unwrapNodes(editor, {
        match: n =>
            !Editor.isEditor(n) &&
            Element.isElement(n) &&
            LIST_TYPES.includes(n.type),
        split: true,
    })
    const newProperties: Partial<Element> = {
      type: isActive ? 'p' : isList ? 'li' : format,
    }
    Transforms.setNodes<Element>(editor, newProperties)
  
    if (!isActive && isList) {
      const block = { type: format, children: [] }
      Transforms.wrapNodes(editor, block)
    }
  }

// STYLES
const BlockButtonWrapper = styled.div<{ active: boolean }>`
    height: 36px;
    width: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${colors.border};
    cursor: pointer;
    transition: .4s ease-out;
    border-radius: 5px;
    background: ${props => props.active ? colors.black : colors.white };
    color: ${props => props.active ? colors.white : colors.black };

    &:hover {
        background: ${props => props.active ? colors.darkGrey : colors.greyBackground};
    }

    svg {
        fill: ${props => props.active ? colors.white : colors.black };
    }
`
